import { Type, TypeBadgeFilled } from '@/lib/core/components/TypeBadgeFilled'

import styles from './ShareCard.module.css'

export type ShareCardProps = {
  type: 'in' | 'out'
  organizationName?: string
  reference?: string
}

export const ShareCard = ({ type, organizationName, reference }: ShareCardProps) => {
  return (
    <div className={styles.card}>
      <div className={styles.meta}>
        <span className={styles.label}>{organizationName || '-'}</span>
        <span className={reference ? styles.reference : styles.referenceMuted}>
          {reference || 'No reference'}
        </span>
      </div>
      <TypeBadgeFilled type={type === 'in' ? Type.IN : Type.OUT} />
    </div>
  )
}
